import { isDevMode } from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../base/reducers';
import { Title } from '@angular/platform-browser';
import * as _ from 'lodash';
var TenantService = /** @class */ (function () {
    function TenantService(store, titleSvc) {
        var _this = this;
        this.store = store;
        this.titleSvc = titleSvc;
        this.customCssUrl = '';
        this.customFaviconUrl = '';
        this.domain = window.location.host.split('.')[0];
        this.fullDomain = window.location.host;
        this.store.pipe(select(fromBase.getAppName))
            .subscribe(function (appName) {
            _this.titleSvc.setTitle(appName);
        });
        this.tenantName$ = this.store
            .pipe(select(fromBase.getTenantCode));
        this.tenantName$
            .subscribe(function (tenantName) {
            if (tenantName) {
                var formattedTenantName = tenantName.replace(/\s/g, '').toLowerCase();
                if (isDevMode()) {
                    _this.customCssUrl = "https://orderfield.blob.core.windows.net/tenant/" + formattedTenantName + "/custom.css";
                }
                else {
                    _this.customCssUrl = "https://cdn1.orderfield.com/tenant/" + formattedTenantName + "/custom.css";
                }
                _this.customFaviconUrl = "https://cdn1.orderfield.com/tenant/" + formattedTenantName + "/favicon.ico";
            }
            else if (_.includes(_this.domain, 'localhost')) {
                _this.customCssUrl = '';
                _this.customFaviconUrl = '/assets/tenant/favicon.ico';
            }
            else if (_this.fullDomain === 'webshop.manen.nl') {
                _this.customCssUrl = "https://cdn1.orderfield.com/tenant/vanmanen/custom.css";
                _this.customFaviconUrl = "https://cdn1.orderfield.com/tenant/vanmanen/favicon.ico";
            }
            else {
                _this.customCssUrl = "https://cdn1.orderfield.com/tenant/" + _this.domain + "/custom.css";
                _this.customFaviconUrl = "https://cdn1.orderfield.com/tenant/" + _this.domain + "/favicon.ico";
            }
            var interval = setInterval(function () {
                var customCss = document.getElementById('customCss');
                var customFavicon = document.getElementById('favicon');
                if (customCss && customFavicon) {
                    customCss.setAttribute('href', _this.customCssUrl);
                    customFavicon.setAttribute('href', _this.customFaviconUrl);
                    clearInterval(interval);
                }
            }, 200);
        });
        setTimeout(function () { return _this.removeGlobalLoader(); }, 1500);
    }
    Object.defineProperty(TenantService.prototype, "currentDomain", {
        get: function () {
            return "" + this.domain.charAt(0).toUpperCase() + this.domain.slice(1);
        },
        enumerable: true,
        configurable: true
    });
    TenantService.prototype.removeGlobalLoader = function () {
        document.getElementById('main').classList.remove('loading');
    };
    return TenantService;
}());
export { TenantService };
